
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 16.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m18.524 10.7.442 1.453a.994.994 0 0 0 1.174.681l1.472-.341a1.339 1.339 0 0 1 1.275 2.218l-1.031 1.111a1 1 0 0 0 0 1.362l1.031 1.111a1.339 1.339 0 0 1-1.275 2.218l-1.472-.341a.994.994 0 0 0-1.174.681l-.442 1.447a1.33 1.33 0 0 1-2.548 0l-.442-1.453a.994.994 0 0 0-1.174-.681l-1.472.341a1.339 1.339 0 0 1-1.275-2.218l1.031-1.111a1 1 0 0 0 0-1.362l-1.031-1.111a1.339 1.339 0 0 1 1.275-2.218l1.472.341a.994.994 0 0 0 1.174-.681l.442-1.453a1.33 1.33 0 0 1 2.548.006ZM3.75 6.75h10.5m-10.5 4.5H7.5m-3.75 4.5H7.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.5 20.25H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h10.629a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V6.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    